import type { IconDef } from '../types';

export const stop: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.59667 4.28711 7.2002C1.4291 11.8038 2.56388 17.695 6.81836 20.335C11.0729 22.9747 16.8548 21.3817 19.7129 16.7891V16.7998C22.5709 12.1962 21.4361 6.305 17.1816 3.66504ZM15.665 7.63672C16.265 7.63672 16.7568 8.12754 16.7568 8.72754V15.665C16.7568 16.265 16.265 16.7568 15.665 16.7568H8.72754C8.12754 16.7568 7.63672 16.265 7.63672 15.665V8.72754C7.63672 8.12754 8.12754 7.63672 8.72754 7.63672H15.665ZM9.70898 14.4766L14.4658 14.6836L14.6729 9.92773L9.91602 9.71973L9.70898 14.4766Z',
    },
  ],
};
